import { yup, strictObjectSchema } from './validationLib.js';
import { InvestmentAccountStatus, InvestmentAccountType } from '../constants/investmentAccountConstants.js';
import { userForSubmitInvestmentAccountSchema } from './userValidations.js';
import { createIncomingTransferRequestSchema, createRecurringDepositSchema } from './transferValidations.js';
import { SystemValidationError } from '../constants/errorCodes.js';

const { REQUIRED_SYSTEM_HANDLED, UNEXPECTED_SYSTEM_HANDLED } = SystemValidationError;

const accountTypeSchema = yup
  .string()
  .label('accountType')
  .oneOf(InvestmentAccountType.ALL_ITEMS, UNEXPECTED_SYSTEM_HANDLED)
  .required('required');

const updateInvestmentAccountTypeSchema = strictObjectSchema({
  accountType: accountTypeSchema,
});

const buildSubmitInvestmentAccountSchemaWithTransfersSchema = (expectedTransferCount) =>
  strictObjectSchema({
    user: userForSubmitInvestmentAccountSchema.required(),

    investmentAccount: strictObjectSchema({
      accountType: accountTypeSchema,
      accountStatus: yup
        .string()
        .oneOf([InvestmentAccountStatus.ONBOARDING], SystemValidationError.INVALID_ACCOUNT_STATE_FOR_REQUEST)
        .required(),
    }).required(),

    transfers: strictObjectSchema({
      transferRequests: yup.array().label('transferRequests').required(REQUIRED_SYSTEM_HANDLED),
      recurringDeposits: yup.array().label('recurringDeposits').required(REQUIRED_SYSTEM_HANDLED),
    }).test('exactly-one-transferRequest-or-recurringDeposit', UNEXPECTED_SYSTEM_HANDLED, function (self) {
      return self.transferRequests.length + self.recurringDeposits.length == expectedTransferCount;
    }),
  });

const submitSelfFundedInvestmentAccountSchema = buildSubmitInvestmentAccountSchemaWithTransfersSchema(1);

const submitEmployerFundedInvestmentAccountSchema = buildSubmitInvestmentAccountSchemaWithTransfersSchema(0);

export {
  updateInvestmentAccountTypeSchema,
  submitSelfFundedInvestmentAccountSchema,
  submitEmployerFundedInvestmentAccountSchema,
};
